import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(exportedSuggestionViaBackend);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import fetch from 'isomorphic-unfetch';
import { call, put, cancelled } from 'redux-saga/effects';
import { SUGGEST_SEARCH_SUCCESS } from '../actions/constants';
import { rebalance } from '../rest/algolia'; // server side: packages/pat-frontend/server/search.js
// we set that because some algolia queries throw error above 512 bytes

var Q_LIMIT = 200;

var suggestionsViaBackend = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _window$sessionStorag, _query$trim;

    var algoliaEndpoint, _ref$payload, query, options, abortSignal, userToken, arrayOfTypesArray, qParam, demoParam, userTokenParam, customerTagParam, results;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          algoliaEndpoint = _ref.algoliaEndpoint, _ref$payload = _ref.payload, query = _ref$payload.query, options = _ref$payload.options, abortSignal = _ref.abortSignal;
          userToken = typeof window !== 'undefined' && ((_window$sessionStorag = window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem('algoliaUid'));
          arrayOfTypesArray = [['speciality', 'expertise'], ['practitioner', 'center']];
          qParam = "q=".concat(((_query$trim = query.trim()) !== null && _query$trim !== void 0 ? _query$trim : '').slice(0, Q_LIMIT).toLowerCase()); // isDemo for demo account, backend should returns both actual and demo items

          demoParam = (options === null || options === void 0 ? void 0 : options.isDemo) === true ? "isDemo=true" : undefined;
          userTokenParam = userToken ? "userToken=".concat(userToken) : undefined;
          customerTagParam = options !== null && options !== void 0 && options.customerTag ? "customerTag=".concat(options.customerTag) : undefined;
          _context.next = 9;
          return Promise.all(arrayOfTypesArray.map(function (types) {
            var typeParam = types.map(function (t) {
              return "type=".concat(t);
            }).join('&');
            var params = [qParam, typeParam, demoParam, userTokenParam, customerTagParam].filter(Boolean) // remove empty values
            .join('&');
            return fetch("".concat(algoliaEndpoint, "/_search?").concat(params), {
              signal: abortSignal
            }).then(function (res) {
              return res.json();
            });
          }));

        case 9:
          results = _context.sent;
          return _context.abrupt("return", rebalance(results.flat()));

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function suggestionsViaBackend(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var noop = function noop() {};

export default function exportedSuggestionViaBackend(algoliaEndpoint, action) {
  var abortController, type, _action$onSuccess, onSuccess, _action$onError, onError, _yield$call2, data;

  return _regeneratorRuntime.wrap(function exportedSuggestionViaBackend$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        abortController = new AbortController();
        type = action.type, _action$onSuccess = action.onSuccess, onSuccess = _action$onSuccess === void 0 ? noop : _action$onSuccess, _action$onError = action.onError, onError = _action$onError === void 0 ? noop : _action$onError;
        _context2.prev = 2;
        _context2.next = 5;
        return call(suggestionsViaBackend, _objectSpread(_objectSpread({
          algoliaEndpoint: algoliaEndpoint
        }, action), {}, {
          abortSignal: abortController.signal
        }));

      case 5:
        _yield$call2 = _context2.sent;
        data = _yield$call2.data;
        onSuccess(data);
        _context2.next = 10;
        return put({
          type: SUGGEST_SEARCH_SUCCESS,
          payload: data
        });

      case 10:
        _context2.next = 17;
        break;

      case 12:
        _context2.prev = 12;
        _context2.t0 = _context2["catch"](2);
        onError(_context2.t0);
        _context2.next = 17;
        return put({
          type: "".concat(type, "_FAILED")
        });

      case 17:
        _context2.prev = 17;
        _context2.next = 20;
        return cancelled();

      case 20:
        if (!_context2.sent) {
          _context2.next = 22;
          break;
        }

        abortController.abort();

      case 22:
        return _context2.finish(17);

      case 23:
      case "end":
        return _context2.stop();
    }
  }, _marked, null, [[2, 12, 17, 23]]);
}
//# sourceMappingURL=suggestionsViaBackend.js.map